





























import { Component, Vue } from "vue-property-decorator";
import { ContractsModule } from "@/store/contracts.module";
import { UsersManagementModule } from "@/store/users-management.module";
import { AuthModule } from "@/store/auth.module";
import { UserPermissions } from "@/config/consts";

@Component
export default class ProfileView extends Vue {
  public created() {
    ContractsModule.setSelectedContract(null);
    UsersManagementModule.getUserRoles();
  }

  get canManageUsers(): boolean {
    return false; // Временная блокировка
    //return AuthModule.permissions.includes(UserPermissions.USERS_MANAGEMENT);
  }
}
